const getPageTemplateFromUrl = () => {
  if (typeof window !== 'undefined') {
    const url = window.location.href;
    const sections = url.split('/');
    if (Array.isArray(sections)) {
      const lastSection = sections[sections.length - 1];
      if (lastSection) {
        if (lastSection.indexOf('?') > 0) {
          return lastSection.split('?')[0];
        }
        return lastSection;
      }
    }
  }
  return '';
};

// eslint-disable-next-line import/prefer-default-export
export const setNavDataInGlobalObj = (navsObj, sectionObj = {}) => {
  // if(navsObj){
  if (typeof window !== 'undefined') {
    const level_1 = navsObj?.subsec1?.subsecnameseo1 || sectionObj.SCN || '';
    const level_2 = navsObj?.subsec2?.subsecnameseo2 || sectionObj.SubSCN || '';
    const level_3 = navsObj?.subsec3?.subsecnameseo3 || '';
    const level_full =
      level_1 + (level_2 ? `/${level_2}` : '') + (level_3 ? `/${level_3}` : '');
    window.Times = window.Times || {};
    window.navsObj = window.navsObj || {};

    window.Times.adsKeys = window.Times.adsKeys || {};
    window.Times.adsKeys = {
      SCN: level_1,
      SubSCN: level_2,
      levelFull: level_full,
      Tmpl_SCN:
        sectionObj?.Tmpl_SCN === 'listing' || sectionObj?.Tmpl_SCN === 'home'
          ? getPageTemplateFromUrl()
          : sectionObj?.Tmpl_SCN,
      section_id: navsObj?.subsec1?.subsecmsid1,
    };
  }
};
